module.exports = {
  WEBDRIVERIO_INPUT_ELEMENT: '.WAC__TextArea-textarea',
  WEBDRIVERIO_INPUT_ELEMENT_VISIBLE_TIMEOUT: 30000,
  WEBDRIVERIO_OUTPUT_ELEMENT_HASH: 'HASH',
  WEBDRIVERIO_OUTPUT_ELEMENT_HASH_ATTRIBUTE: 'id',
  WEBDRIVERIO_OUTPUT_ELEMENT: '//div[contains(@class,\'WAC__message \') and descendant::div[contains(@class,\'WAC__bot-message\')] and not(descendant::div[contains(@class,\'WAC__received--loading\')])]',
  WEBDRIVERIO_IGNOREWELCOMEMESSAGES: 1
}
